import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`

  body {
    -webkit-font-smoothing: antialiased;
  }

  html, body, #root {
    //background: #ccc;
    height: 100% !important;
  }

  .navbar {
    background: #330d87 !important;
  }

  .sidebar {
    background-color: #330d87 !important;
    position: fixed !important;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    //z-index: 100; /* Behind the navbar */
    //padding: 48px 0 0; /* Height of navbar */
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
  }

  .sidebar-sticky {
    background: #330d87 !important;
    position: relative;
    top: 0;
    height: 100%;
    padding-top: .5rem;
    overflow-x: hidden;
    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
  }

  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
    }
  }

  .sidebar .nav-link {
    cursor: pointer;
    text-align: center;
    align-items: center;
    font-weight: 500;
    color: white;
  }

  .sidebar .nav-link .feather {
    margin-right: 4px;
    color: #999;
  }

  .sidebar .nav-link.active {
    background: rgba(0, 0, 0, .3);
    color: #fff;
  }

  .sidebar .nav-link:hover .feather,
  .sidebar .nav-link.active .feather {
    color: inherit;
  }

  .sidebar-heading {
    font-size: .75rem;
    text-transform: uppercase;
  }

  .sidebar-brand {
    margin: 20px 0 20px 0;
    padding: 10px 0 10px 0;
  }

  /*
   * Content
   */

  [role="main"] {
    padding-top: 10px; /* Space for fixed navbar */
    height: 100%;
  }

  /*
   * Navbar
   */

  .navbar-brand {
    padding-top: .75rem;
    padding-bottom: .75rem;
    font-size: 1rem;
    background-color: rgba(0, 0, 0, .25);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
  }

  .navbar .form-control {
    padding: .75rem 1rem;
    border-width: 0;
    border-radius: 0;
  }

  .form-control-dark {
    color: #fff;
    background-color: rgba(255, 255, 255, .1);
    border-color: rgba(255, 255, 255, .1);
  }

  .form-control-dark:focus {
    border-color: transparent;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
  }

  .form-button {
    margin-bottom: 20px;
  }

  .item-click:hover {
    cursor: pointer;
  }

  .button-signin {
    margin-top: 15px;
    background: #EC7597 !important;
    width: 100px;
  }

  .clube-button {
    margin: 15px 0px 80px 0;
    min-width: 100px !important;
  }

  .clube-blue {
    background: #330d87 !important;
    color: white !important;
  }

  .clube-form {
    margin-top: 50px;
  }

  .clube-page-link {
    color: #330d87 !important;
    font-weight: bold;
  }

  .component-top {
    margin: 40px 0 40px 0 !important;
  }

  .facilities {
    margin: 20px 0 20px 0;
  }

  .form-titles {
    margin: 10px 0 10px 0 !important;
  }

  .clube-btn {
    margin-left: 10px;
    margin-right: 10px;
  }

  .partner-logo {
    padding: 10px;
    background: #ccc;
    max-height: 200px !important;
    max-width: 100% !important;
  }

  .crop-container {
    position: absolute;
    max-width: 240px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 80px;
  }

  .controls {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 50%;
    transform: translateX(-50%);
    height: 80px;
    display: flex;
    align-items: center;
  }

  .slider {
    padding: 22px 0px;
  }

  .clube-crop {
    max-height: 450px !important;
  }

  .unity-images {
    max-width: 200px;
    max-height: 200px;
  }

  .ImagesList li {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .drag-area {
    background: darkslateblue;
    min-height: 100px;
    padding: auto;
    font-weight: bold;
    color: white;
  }

  .drag-area:hover {
    cursor: pointer;
  }

  .padding-bottom-label {
    padding-bottom: 20px;
  }

  .login-background {
    background: #330f87;
  }

  .login-text {
    margin-top: 10px;
    color: white;
    font-size: large;
  }

  .login-container {
    background: #EC7597 !important;
  }

  .forms-title {
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .clube-20-botom-margin {
    margin-bottom: 20px;
  }

  .clipping-card {
    background: #cccccc !important;
    height: 250px;
    padding: 10px;
    margin-bottom: 100px;
    border: solid 1px #330f87 !important;

  }

  .clipping-card > img {
  max-height: 100%;
  }

  .clipping-card-header  {
    width: 100%;
    height: 100%;

  }

  .clipping-card-header > img  {
    margin: auto;
  }

  .text-clube {
    color: #330f87;
  }

  .form-container {
    margin-top: 40px;
  }

  .clube-clipping-logo-parent {
    width: 285px;
    height: 285px;
  }

  .clube-clipping-logo {
    width:100%;
    margin: 10px;
    background-color: #b3b7bb;
    padding: 10px;
    border: solid 1px #330f87 !important;
    border-radius: 4px;
  }

  .clube-clipping-logo > img {
    max-width:100%;
    max-height: 100%;
    object-fit: contain;
  }

  .clube-clipping-labels {

    margin: 10px;
    background-color: #b3b7bb;
    padding: 10px;
    border: solid 1px #330f87 !important;
    border-radius: 4px;
  }

  .clube-clipping-inputs-group {
    min-height: 250px;

  }

  .clube-clipping-inputs {
    height: 50px;
  }

  .clube-clipping-inputs > input {
    height: 100%;
  }

  .clube-send {
    height: 120px;
    border: solid 1px #330f87 !important;
    border-radius: 4px;
  }

  .clube-send-icon {
    height: 100%;
    font-size: 40px;
    width: 45px;
    margin-right: 15px;
    margin-left: 30px;
    color: #330f87;
  }

  .clube-send-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

  }

  .clube-send-text {
    font-size: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-height: 90%;
    padding-right: 20px;
    color: #330f87;
    font-weight: bold;
    word-wrap: break-word;
  }

  .clube-border {
    border: solid 1px #330f87 !important;
    border-radius: 4px;
  }

  .clube-border-danger {
    border: solid 1px red !important;
    border-radius: 4px;
  }

  .clube-border-clipping-img {
    margin-top: 10px;
    border: solid 4px #330f87 !important;
    border-radius: 8px;
  }

  .clube-border-clipping-capa-span {
    margin-top: -25px;
    background-color: #330f87;
    color: white;
    max-width: 110px;
    text-align: center;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

  }

  .clube-link-button-group {
    width: 60px;

  }

  .clube-link-button-edit {
    width: 50px;
    height: 50px;
    font-size: 20px;
    color: white;
    background-color: #330f87;
    border-radius: 30px;
  }

  .clube-link-button-trash {
    width: 50px;
    height: 50px;
    font-size: 20px;
    color: white;
    background-color: red;
    border-radius: 30px;
  }

  .club-preview-logo {
    background-color: grey;
    width: 70px;
  }

  .club-preview-logo-img {
    max-width: 100%;
    object-fit: contain;
  }

  .club-preview-header {
    margin-bottom: 25px;
  }

  .club-preview-image-group {
    padding: 10px;
    margin-bottom: 25px;
  }

  .club-preview-image {
    height: 90%;
    width: 90%;
  }

  .club-container {
    margin-top: 100px;
  }

  .club-preview-image-group {
    border: solid 1px #330f87 !important;
    border-radius: 4px;
    background-color: #dedede;
  }

  .club-list-user-validated {
    min-height: 80px;
    margin-bottom: 10px;
  }

  .card-img-top{
    height: 300px;
    object-fit: contain;
    background-color: #b9bbbe;
  }

  .club-html-editor{
    height: 300px !important;

  }

  .nav-item-left-text {
    padding: 10px !important;

    text-align: start !important;
  }

  .coupons-tab-item {
    font-weight: bold;
    border-bottom: solid 8px;
    color: #5f6061;
  }

  .coupons-tab-active-item {
    color: #330f87 !important;
    border-bottom: solid 8px #330f87 !important;
  }

  .accordion-width {
    width: 100% !important;
  }

  .collapse-header {
    background-color: white;
    border: 0px;

  }

  .coupons-header {
    font-weight: bold;
    font-size: 18px;
    color: #5f6061;
    padding-top: 5px;
  }

  .coupons-text {
    font-weight: bold;
    font-size: 18px;

    justify-items: center;
    align-items: center;

  }

  .coupons-numbers {
    font-weight: bold;
    font-size: 50px;
  }

  .text-club-blue {
    color: #330f87;
  }

  .clube-coupons-add-area-parent {
     width: 250px;
    height: 250px;
  }

  .clube-coupons-add-area {
    width: 100%;

    background-color: #330f87;
    padding: 10px;
    border: solid 1px #330f87 !important;
    border-radius: 5px;
  }

  .clube-coupons-add-area>p {
    color: white;
    font-size: 20px;
    text-align: center;
    font-weight: bold;

  }

  .clube-download-model-button {
    background-color: #330f87;
    width: 120px;
    color: white;
    font-size: 25px;
    text-align: center;

  }

  .clube-download-model-button>p {
    font-size: 18px;
  }

  .coupons-h4 {
    margin-top: 30px;
    margin-left: 15px;
    color: #330f87;
  }

  .partner-select-area {
    border: solid 1px #330f87 !important;
    border-radius: 4px;
    padding: 5px;
  }

  .card-clube {
    height: 100%;
  }

  .rv-xy-plot  {
    width: 100% !important;
  }

  .MuiGridListTileBar-subtitle {
    margin-top: 15px;

  }

  .clube-title {
    margin-bottom: 25px;
    color: #301684;
    font-weight: bold;
  }

  .clube-subtitle {
    margin-top: -25px;
    color: gray;
    font-size: 15px;
  }

  .nice-dates-day {
    height: 50px !important;
  }

  .nice-dates-day:before {
    background-color: #250074;
  }
  .nice-dates-popover {
    border: 1px solid #ddd;
    width: 350px;
    transition: none;
  }

`

export default GlobalStyle
